import React, { Component } from 'react';
import CustomLoader from '../../common/Loader';
import { getDT, loadDT } from '../../../services/formService';
import { Modal } from "react-bootstrap";
import { RowActions } from '../../../constants/ResultSource';
import FormViewer from '../FormViewer';
import { withRouter } from 'react-router-dom';
import { getProjectForms } from '../../../services/projectService';
import { ListGroup, ListGroupItem } from 'react-bootstrap';
import _ from 'lodash';
import queryString from 'query-string';
import MUIDataTable from "mui-datatables";

class DataTableViewer extends Component {
	state = {
		Widget_ID: this.props.Widget_ID,
		Form_ID: this.props.Form_ID,
		DT_ID: 0,
		Display_Name: '',
		Action_ID: 0,
		Action_Form_ID: 0,
		Project_Forms: [],
		dataTable: { columns: [], rows: [] },
		open: false,
		dialog_x: 0,
		dialog_y: 0,
		row_pk: '',
		pk_col: null,
		content: null,
		PrimaryKey: this.props.PrimaryKey ? this.props.PrimaryKey : '',
		Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
		selectedInst: document.getElementById('userInst'),
		LightMode: this.props.LightMode,
		loading: true,
		filterParametersList: [],
		parametersList: [''],
		hasServerSidePaging: false,
		hasDownloadDT: false,
		hasPrintDT: false,
		hasFilterDT: false,
		minCharCountSearchDT: 3,
		countDT: undefined,
		searchTextDT: ''
	};

	async componentDidMount() {
		this.loadData();
		this.handleClick = this.handleClick.bind(this);
	}

	componentDidUpdate(prevProps, prevState) {
		const prevPropsFilteredList = prevProps.FilterParametersList.map((obj) => obj.Value);
		const propsFilteredList = this.props.FilterParametersList.map((obj) => obj.Value);
		if (prevPropsFilteredList.toString() !== propsFilteredList.toString()) {
			this.setState({ filterParametersList: this.props.FilterParametersList }, () => {
				this.loadData();
			});
		}
	}

	handleNavigate = (Form_ID, pk, pk_name) => {
		let isSameLevel = !!queryString.parse(window.location.search).form_id
		this.props.history.push(`/form?form_id=${Form_ID}&project_id=${document.getElementById('projectSelected').getAttribute('name')}&inst_id=${(this.state.selectedInst).value}`, {
			Form_ID: Form_ID,
			SurveyMode: true,
			PrimaryKey: pk,
			PK_Name: pk_name,
			Project_ID: this.state.Project_ID,
			Form_SecondaryIDValue: this.state.Form_SecondaryIDValue,
			selectedInst: (this.state.selectedInst).value
		});
		isSameLevel && window.location.reload();
	};

	handleClick = (rowData, e) => {
		const { pk_col, Action_Form_ID } = this.state;
		//if (pk_col) {
			var row_pk = ('PK_Value' === this.state.dataTable.columns[0].name) ? rowData[0] : undefined;
			this.setState({ row_pk });
		//}

			if (this.state.Action_ID === RowActions.Navigate && Action_Form_ID !== 0) {
				this.handleNavigate(Action_Form_ID, row_pk, rowData.PK_Name);
			} else {
				this.setState({ dialog_x: e.clientX });
				this.setState({ dialog_y: e.clientY });
				(Action_Form_ID !== 0) && this.setState({ open: true });
				let content = null;
				if (this.state.Action_ID === RowActions.Show) {
					content = 
						<FormViewer 
							Form_ID={Action_Form_ID}
							LightMode={true}
							PrimaryKey={row_pk}
							Project_ID={this.state.Project_ID}
							isPopUp={true}
							PK_Name={'Participant ID'}
							Form_SecondaryIDValue={('AE#' === this.state.dataTable.columns[0].name) ? rowData[0] : undefined}
							selectedInst={(this.state.selectedInst).value}
						/>;
				} else if (this.state.Action_ID === RowActions.Navigate) {
					content = (
						<ListGroup>
							{this.state.Project_Forms.map((form) => (
								<ListGroupItem action key={'nav' + form.Form_ID} onClick={() => this.handleNavigate(form.Form_ID, row_pk, rowData.PK_Name)}>
									{form.Form_Name}
								</ListGroupItem>
							))}
						</ListGroup>
					);
				}
				this.setState({ content });
			}
		//}
	};

	handleClickAway = () => {
		this.setState({ open: false });
	};

	loadData = async () => {
		let { filterParametersList } = this.state;

		if (this.state.PrimaryKey) {
			filterParametersList = [...filterParametersList,
			{
				'Parameter_ID': null,
				'Name': 'pk_value',
				'Type': 'text',
				'Default_Value': this.state.PrimaryKey,
				'List_ID': null,
				'Value': this.state.PrimaryKey
			}
			]
		}

		const parameterValues = _(filterParametersList).map((obj) => {
			return (obj.Name === '@Institution_ID') ? (this.state.selectedInst).value : obj.Value;
		})
		//.filter(obj=> obj !=='')
		.value();

		//console.log('parameterValues', parameterValues, filterParametersList);
	
		this.setState({ hasServerSidePaging: filterParametersList.find(param => param['Name'] === '@DT_Action') })
		const addedFilters = filterParametersList.length > 0 ? { Parameters_Set: [parameterValues].join() } : {};
		//console.log('addedFilters: ', addedFilters, this.state.hasServerSidePaging)
		this.setState({addedFilters});
		const { data } = await loadDT({ wID: this.state.Widget_ID, ...addedFilters, DTChange: null });
		if (typeof data === 'object') {
			let columns = JSON.parse(data.Columns);

			let pk_col = columns.find((col) => {
				return col.isPrimary;
			});
			this.setState({ pk_col });

			columns = columns
				.filter((col) => col.Visible)
				.map((col) => {
					return {
						name: col.Column_Name,
						label: col.Column_Display_Name,
						options: {
							setCellHeaderProps: value => ({ style: { 'color': '#0061F2' } }),
							setCellProps: value => ({ style: { 'color': '#687281', 'fontSize': 'medium', 'fontFamily': 'Metropolis' } }), //'font-weight': 'bold'
						}
					};
				});

			const DT = data.DT;
			if (DT) {
				this.setState({
					DT_ID: DT.DT_ID,
					Action_ID: DT.Action_ID,
					Action_Form_ID: DT.Action_Form_ID,
					hasServerSidePaging: (DT.enableServerSidePaging === true) ,//&& (this.state.filterParametersList.find((param) => param['Name'] === '@DT_Action') !== undefined),
					hasDownloadDT: (DT.enableDownloadDT === true),
					hasPrintDT: (DT.enablePrintDT === true),
					hasFilterDT: (DT.enableFilterDT === true)
				});

				//if (DT.Action_Form_ID === 0) {
					let { data: Project_Forms } = await getProjectForms(this.state.Project_ID);
					Project_Forms = Project_Forms.filter((form) => form.Form_ID !== this.state.Form_ID && form.Active);
					this.setState({ Project_Forms });
				//}

				this.setState({
					Display_Name: this.state.primary_key ? '' : DT.Display_Name,
				});
			}
			
			let instCode = (this.state.selectedInst) && (this.state.selectedInst).options[(this.state.selectedInst).selectedIndex].getAttribute('code'),
				handleClick = this.handleClick;
			this.setState({ institutionCode: instCode });
			let Form_ID= this.state.Form_ID, rows = JSON.parse(data.Data).map(function (row) {
				if ((Form_ID !== 19 && row['PK_Name'] !== 'Participant ID') || (row['PK_Name'] === 'Participant ID' && row['PK_Value'].substring(0, 2) === instCode)) {
					return {
						...row,
						clickEvent: (e) => handleClick(e, row),
					}
				}
			});
			rows = rows.filter(e => e !== undefined);
			this.setState({ dataTable: { columns: columns, rows: rows[0] !== undefined ? rows : [] } });
			//console.log('hasServerSidePaging:: ', this.state.hasServerSidePaging)
			let countDT = this.state.hasServerSidePaging && this.state.dataTable.rows[0] && this.state.dataTable.rows[0]['DT_TotalRecords'] ? this.state.dataTable.rows[0]['DT_TotalRecords'] : undefined;
			this.setState({countDT});
			//Set DataTable Options
			let DTOptions = {
				filter: this.state.hasFilterDT,
				filterType: 'textField',
				download: this.state.hasDownloadDT,
				print: this.state.hasPrintDT,
				responsive: 'simple',
				selectableRowsHeader: false,
				selectableRows: 'none',
				pagination: true,
				rowsPerPageOptions: [10, 15, 30, 50, 100],
				//customSearchRender: this.state.hasServerSidePaging? debounceSearchRender(500) : undefined,
				serverSide: this.state.hasServerSidePaging,
				jumpToPage: !( this.state.hasServerSidePaging), //TODO Server-side
				count: this.state.countDT, //get total records count 
				rowsPerPage: this.state.hasServerSidePaging ? filterParametersList.find(param => param['Name'] === '@DT_PageSize').Value : (this.state.LightMode ? 10 : 30),
				page: this.state.hasServerSidePaging ? (filterParametersList.find(param => param['Name'] === '@DT_PageNumber').Value) -1  :  0,
				sortOrder: {
					'name': this.state.filterParametersList.filter((o) => o.Name == '@DT_SortColumn').Value || undefined,
					'direction': this.state.filterParametersList.filter((o) => o.Name == '@DT_SortOrder').Value || 'ASC'
				},
				onTableChange: (action, tableState) => {
					var debounce = _.debounce(function () {
						let searchTextDT = tableState.searchText === null ? this.state.searchTextDT : tableState.searchText; //retain search for other actions
						this.setState({ searchTextDT });
						if (this.state.hasServerSidePaging &&
							(action === 'changePage' || action === 'changeRowsPerPage' || action === 'sort' ||
								(action === 'search' && (searchTextDT === '' || searchTextDT.length >= this.state.minCharCountSearchDT)))) { //min chars to search
							this.setState({ loading: true });
							//console.log('onTableChange: ', tableState.searchText, action);
							let DTSortOrder = '', DTOptions = this.state.DTOptions;
							if (Object.keys(tableState.sortOrder).length === 0) { //action is not related to sort => retain default order
								let defaultOrderObj = this.state.filterParametersList.filter((o) => o.Name == '@DT_SortColumn')[0] || []
								DTSortOrder = defaultOrderObj.Value + ',' + this.state.filterParametersList.filter((o) => o.Name == '@DT_SortOrder')[0].Value;
							}
							else {
								DTSortOrder = tableState.sortOrder.name + ',' + (tableState.sortOrder.direction).toUpperCase();
							}
							//Update all state variables
							DTOptions['rowsPerPage'] = tableState.rowsPerPage;
							DTOptions['page'] = tableState.page;
							DTOptions['sortOrder'] = tableState.sortOrder;
							//Update DT state and get latest data
							let DTChange = action + ',' +
								(tableState.page + 1) + ',' +
								tableState.rowsPerPage + ',' +
								DTSortOrder + ',' +
								(this.state.selectedInst).value + ',' +
								this.state.searchTextDT;
							console.log('DTChange', DTChange, action)
							try {
								loadDT({ wID: this.state.Widget_ID, ...this.state.addedFilters, DTChange: DTChange }) //send values only in the array
									.then(async (response) => {
										let dataTable = this.state.dataTable;
										dataTable['rows'] = (response.data.Data) ? JSON.parse(response.data.Data) : [];
										return dataTable;
									})
									.then((dataTable) => {
										let countDT = dataTable.rows[0]['DT_TotalRecords'];
										//console.log('dataTable', dataTable['rows'], countDT)
										DTOptions['count'] = countDT;
										this.setState({ countDT, DTChange, DTOptions, dataTable, loading: false });
									});
							}
							catch (e) {
								console.error('Error Loading DataTable: ', e);
								let dataTable = this.state.dataTable;
								dataTable['rows'] = [];
								this.setState({ dataTable, searchTextDT: '', loading: false });
							}
						}
					}, this.state.hasServerSidePaging ? 1000 : undefined).bind(this);
					debounce();
				},
				onRowClick: (rowData, rowMeta) => {
					this.handleClick(rowData, rowMeta);
				},
				onSearchClose: (searchStr) => {
					//console.log('onSearchClose event: ', searchStr);
					let searchTextDT = searchStr === undefined ? '' : this.state.searchTextDT;
					this.setState({ searchTextDT });
				}
			}
			this.setState({ DTOptions, loading: false });
		}
	};

	render() {
		if (this.state.loading) {
			return <CustomLoader loading={this.state.loading} />;
		}
		const { content, DTOptions, dataTable  } = this.state;

		return (
			<div className='card'>
				<div className='card-body' key = {this.state.DTOptions} id='customDT'>
					<MUIDataTable
						key={DTOptions}
						title={this.state.Display_Name}
						columns={dataTable['columns']}
						data={dataTable['rows'] || []}
						options={DTOptions}
					/>
				</div>
				<Modal size='xxl' show={this.state.open} onHide={() => {this.setState({ open: false });}}>
					<Modal.Header closeButton></Modal.Header>
					<Modal.Body className='container'>{content}</Modal.Body>
				</Modal>
			</div>
		);
	}
}

export default withRouter(DataTableViewer);
